import { render, staticRenderFns } from "./bindSet.vue?vue&type=template&id=b6b9fab8&scoped=true&"
import script from "./bindSet.vue?vue&type=script&lang=js&"
export * from "./bindSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b9fab8",
  null
  
)

export default component.exports